// Column classes for the care-card row. Rows are balanced (6 cards on desktop is 3+3, not 5+1)
// and a single card is capped at half width. Class strings are spelled out so Tailwind sees them.
const MAX_COLS = {base: 1, sm: 2, md: 3, lg: 4, xl: 5} as const;

const COL_CLASSES = {
  base: ['grid-cols-1'],
  sm: ['sm:grid-cols-1', 'sm:grid-cols-2'],
  md: ['md:grid-cols-1', 'md:grid-cols-2', 'md:grid-cols-3'],
  lg: ['lg:grid-cols-1', 'lg:grid-cols-2', 'lg:grid-cols-3', 'lg:grid-cols-4'],
  xl: ['xl:grid-cols-1', 'xl:grid-cols-2', 'xl:grid-cols-3', 'xl:grid-cols-4', 'xl:grid-cols-5'],
} as const;

/** Columns for `count` cards when at most `max` fit: fill the row, else balance the rows. */
export function balancedColumns(count: number, max: number): number {
  if (count <= 0) return 1;
  if (count === 1) return Math.min(2, max);
  if (count <= max) return count;
  return Math.ceil(count / Math.ceil(count / max));
}

export function careCardGridClass(count: number): string {
  return (Object.keys(MAX_COLS) as Array<keyof typeof MAX_COLS>)
    .map((bp) => COL_CLASSES[bp][balancedColumns(count, MAX_COLS[bp]) - 1])
    .join(' ');
}
